import { CommonModel } from "src/app/core/models/shared/commone.model";

export const monthDatalist: CommonModel[] = [
  { "id": 1, "name": "มกราคม", },
  { "id": 2, "name": "กุมภาพันธ์", },
  { "id": 3, "name": "มีนาคม", },
  { "id": 4, "name": "เมษายน", },
  { "id": 5, "name": "พฤษภาคม", },
  { "id": 6, "name": "มิถุนายน", },
  { "id": 7, "name": "กรกฎาคม", },
  { "id": 8, "name": "สิงหาคม", },
  { "id": 9, "name": "กันยายน", },
  { "id": 10, "name": "ตุลาคม", },
  { "id": 11, "name": "พฤศจิกายน", },
  { "id": 12, "name": "ธันวาคม", },
];

export const daysDatalist: number[] = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];